<ng-container *ngIf="isLoadingPermissions; else loadedPermissions">
    <ngx-skeleton-loader
        count="5"
        [theme]="{ 
            'height.px': 50
        }"
    ></ngx-skeleton-loader>
</ng-container>
<ng-template #loadedPermissions>
    <app-data-grid-comp
        [columns]="columns"
        [filterCategories]="filterCategories"
        [sortableColumns]="sortableColumns"
        [gridDataResult]="gridDataResult"
        [isLoading]="isLoading"
        [pageSize]="pageSize"
        [tableId]="db_tables.BankDetails"
        [skip]="skip"
        category="BankDetails"
        [rowSelectionSettings]="{
            canSelectRows: true,
            selectableMode: 'multiple',
            selectRowBy: 'id'
        }"
        clickableRows="true"
        [clearSelectedItems]="clearSelectedItems"
        [accessAndHistoryURL]="accessAndHistoryURL"
        [parentModelId]="employeeID"
        [targetEmployeeTablePermissions]="targetEmployeeTablePermissions"
        [sortable]="{
            mode: 'multiple'
        }"
        (emitGridStateChangeEvent)="gridStateChange($event)"
        (emitOpenDialogEvent)="getBankDetail($event)"
        (emitDeleteEvent)="deleteBankDetails($event)"
    ></app-data-grid-comp>
</ng-template>